export default {
  methods: {
    preventDesktop(func) {
      if (window.matchMedia("(min-width:1025px").matches) {
        return;
      } else {
        return func;
      }
    }
  }
};
